import { Link } from 'react-router-dom';
import { DocentesList } from '@components/home/DocentesList';
import styles from './Home.module.css';

export const Home: React.FC = () => {
  return (
    <div className={styles.home}>
      <section className={styles.hero}>
        <h2 className={styles.heroTitle}>Bienvenidos al Curso de Mejoramiento Genético Vegetal</h2>
        <p className={styles.heroDescription}>
          Este sitio contiene el material completo del curso de Mejoramiento Genético Vegetal de la
          Facultad de Ciencias Agropecuarias de la Universidad Nacional de Córdoba. Aquí encontrarás
          contenido teórico, herramientas interactivas, trabajos prácticos y recursos para tu
          aprendizaje.
        </p>
      </section>

      <section className={styles.features}>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>📖</div>
          <h3>15 Unidades Temáticas</h3>
          <p>
            Contenido completo desde introducción al mejoramiento hasta técnicas avanzadas de
            biotecnología y edición genómica.
          </p>
          <Link to="/unidad/1" className={styles.featureLink}>
            Ver Unidades →
          </Link>
        </div>

        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>🧮</div>
          <h3>Herramientas Interactivas</h3>
          <p>
            Calculadoras y simuladores para heredabilidad, selección, endocría, heterosis y diseño
            experimental.
          </p>
          <Link to="/herramientas-online" className={styles.featureLink}>
            Ver Herramientas →
          </Link>
        </div>

        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>🔬</div>
          <h3>Trabajos Prácticos</h3>
          <p>
            Actividades prácticas de laboratorio y campo para aplicar los conceptos teóricos del
            curso.
          </p>
          <Link to="/trabajos-practicos" className={styles.featureLink}>
            Ver TPs →
          </Link>
        </div>

        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>💼</div>
          <h3>Proyectos Finales</h3>
          <p>
            Propuestas de proyectos integradores para profundizar en áreas específicas del
            mejoramiento genético.
          </p>
          <Link to="/proyectos-finales" className={styles.featureLink}>
            Ver Proyectos →
          </Link>
        </div>
      </section>

      <section className={styles.content}>
        <DocentesList />

        <div className={styles.section}>
          <h3>🎯 Objetivos de la Cátedra</h3>
          <ul className={styles.list}>
            <li>
              Comprender los principios genéticos fundamentales que rigen la herencia de caracteres
              en plantas
            </li>
            <li>
              Dominar los métodos clásicos y modernos de mejoramiento en especies autógamas,
              alógamas y de propagación vegetativa
            </li>
            <li>
              Aplicar técnicas de selección, evaluación y análisis estadístico en programas de
              mejoramiento
            </li>
            <li>
              Conocer las herramientas biotecnológicas actuales y su integración en el mejoramiento
              vegetal
            </li>
            <li>
              Diseñar estrategias de mejoramiento considerando objetivos productivos y contexto
              agroecológico
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <h3>📚 Contenidos Principales</h3>
          <div className={styles.topics}>
            <div className={styles.topic}>
              <h4>Fundamentos (Unidades 1-4)</h4>
              <p>
                Introducción al mejoramiento, bases genéticas, variabilidad, heredabilidad y
                correlaciones genéticas
              </p>
            </div>
            <div className={styles.topic}>
              <h4>Métodos (Unidades 5-9)</h4>
              <p>
                Selección, mejoramiento en autógamas y alógamas, híbridos, métodos de reproducción
                asexual
              </p>
            </div>
            <div className={styles.topic}>
              <h4>Técnicas Avanzadas (Unidades 10-15)</h4>
              <p>
                Biotecnología, marcadores moleculares, transgénesis, genómica, edición génica y
                bioseguridad
              </p>
            </div>
          </div>
        </div>

        <div className={styles.infoBox}>
          <h3>ℹ️ Información del Espacio Curricular</h3>
          <p>
            <strong>Facultad:</strong> Ciencias Agropecuarias (FCA) - Universidad Nacional de
            Córdoba (UNC)
          </p>
          <p>
            Carreras de Ingeniería Agronómica e Ingeniería Zootecnista
          </p>
          <p>
            Son 52 hs totales de las cuales 20 hs son teóricas y 32 hs son teórico prácticas, con
            un total de horas semanales que van desde las 4 hs hasta las 6,5 hs.
          </p>
        </div>
      </section>
    </div>
  );
};
